import type { Component } from 'vue/types/options';

export async function getVueNgwMapComponent(): Promise<Component> {
  return import(
    /* webpackChunkName: "vue-ngw-cesium" */ '../components/VueNgwCesium/VueNgwCesium'
  ) as Component;
}
